interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  tone?: "default" | "inverse";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  tone = "default",
}: SectionHeadingProps) {
  const isInverse = tone === "inverse";
  return (
    <div
      className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}
    >
      <span
        className={`inline-flex items-center gap-2 rounded-full px-3 py-1 font-label text-xs font-medium tracking-wide ${
          isInverse
            ? "bg-background-50/15 text-background-100"
            : "bg-primary-100 text-primary-800"
        }`}
      >
        <i className="ri-play-circle-line text-sm"></i>
        {eyebrow}
      </span>
      <h2
        className={`mt-4 font-heading text-2xl font-bold leading-snug md:text-4xl ${
          isInverse ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p
          className={`mt-3 text-sm leading-relaxed md:text-base ${
            isInverse ? "text-background-200" : "text-foreground-600"
          }`}
        >
          {description}
        </p>
      )}
    </div>
  );
}